"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _accordion = require("../styles/accordion"),
    _Icon = _interopRequireDefault(require("../../Icon"));

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Accordion = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onAnimationEnd = (0, _memoizeOne["default"])(function (a) {
      return function () {
        var b = d.state.panelRefs;
        b[a].removeEventListener("transitionend", d.onAnimationEnd(a)), d.setState({
          animating: !1
        });
      };
    }), d.selectAccordion = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.state,
            c = b.scrollHeights,
            e = b.panelRefs,
            f = b.selectedAccordionIndex,
            g = (0, _toConsumableArray2["default"])(c);
        g.splice(a, 0, e[a].scrollHeight), a !== f && e[a].addEventListener("transitionend", d.onAnimationEnd(a)), d.setState({
          scrollHeights: g,
          animating: !0
        }, function () {
          setTimeout(function () {
            d.setState({
              selectedAccordionIndex: a === f ? void 0 : a
            });
          });
        });
      };
    }), d.setChildRefs = (0, _lodash["default"])(function (a) {
      return function (b) {
        b && d.setState(function (c) {
          var d = c.panelRefs,
              e = c.scrollHeights,
              f = (0, _toConsumableArray2["default"])(d),
              g = (0, _toConsumableArray2["default"])(e);
          return f.splice(a, 0, b), g.splice(a, 0, b.scrollHeight), {
            panelRefs: f,
            scrollHeights: g
          };
        });
      };
    }), d.renderSingleAccordion = function (a, b) {
      var c = d.props.titles,
          e = d.state,
          f = e.selectedAccordionIndex,
          g = e.scrollHeights,
          h = e.animating,
          i = f === b,
          j = i ? "".concat(g[b], "px") : "0";
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_accordion.ACCORDION, "accordion"),
        key: b
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_accordion.TITLE_WRAPPER, "accordion__title-wrapper"),
        tabIndex: 0,
        role: "button",
        onClick: d.selectAccordion(b),
        onKeyPress: d.selectAccordion(b)
      }, _react["default"].createElement("p", {
        className: (0, _classnames["default"])(_accordion.TITLE, "accordion__title")
      }, Array.isArray(c) ? c[b] : c), _react["default"].createElement(_Icon["default"], {
        color: "white",
        size: 10,
        name: i ? "chevronup" : "chevrondown"
      })), _react["default"].createElement("div", {
        className: (0, _classnames["default"])((0, _accordion.PANEL)(h || !i ? j : "inherit"), "accordion__panel"),
        ref: d.setChildRefs(b)
      }, a));
    }, d.state = {
      scrollHeights: [],
      panelRefs: [],
      animating: !1,
      selectedAccordionIndex: void 0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props.children;
      return _react["default"].createElement("div", null, Array.isArray(a) ? a.map(this.renderSingleAccordion) : this.renderSingleAccordion(a, 0));
    }
  }]), b;
}(_react.Component),
    _default = Accordion;

exports["default"] = _default;